// frontend/src/store/productStore.js
import { create } from 'zustand';
import { productService } from '../services/api';

export const useProductStore = create((set, get) => ({
  // ========== Data State ==========
  products: [],
  categories: [],
  featuredProducts: [],
  newestProducts: [],
  selectedProduct: null,
  loading: false,
  error: null,
  
  // Pagination State - اصلاح شده
  pagination: {
    count: 0,
    totalPages: 1,
    currentPage: 1,
    pageSize: 12,
  },
  
  // ========== Filter State ==========
  selectedCategory: null,
  searchQuery: '',
  priceRange: { min: '', max: '' },
  sortBy: '-created_at',
  viewMode: 'grid',
  
  // ========== Data Actions ==========
  
  // دریافت لیست محصولات - اصلاح شده کامل
  fetchProducts: async (filters = {}) => {
    set({ loading: true, error: null });
    try {
      // ساخت پارامترها با مقادیر پیش‌فرض
      const params = {
        page: filters.page || get().pagination.currentPage,
        page_size: filters.page_size || get().pagination.pageSize,
        ordering: filters.ordering || get().sortBy,
      };
      
      // اضافه کردن فیلترهای اختیاری
      if (filters.category) params.category = filters.category;
      if (filters.search) params.search = filters.search;
      if (filters.min_price) params.min_price = filters.min_price;
      if (filters.max_price) params.max_price = filters.max_price;
      if (filters.min_power) params.min_power = filters.min_power;
      if (filters.max_power) params.max_power = filters.max_power;
      if (filters.brand) params.brand = filters.brand;
      if (filters.seller) params.seller = filters.seller;

      console.log('Sending params to API:', params); // دیباگ

      const response = await productService.getAll(params);
      
      console.log('API response:', response.data); // دیباگ
      
      // استخراج داده‌ها
      const productsList = response.data?.results || response.data || [];
      const count = response.data?.count || 0;
      const pageSize = params.page_size;
      const totalPages = Math.ceil(count / pageSize);
      
      // به‌روزرسانی state
      set({ 
        products: productsList,
        pagination: {
          count: count,
          totalPages: totalPages,
          currentPage: params.page,
          pageSize: pageSize,
        },
        loading: false,
        error: null
      });
      
      return { products: productsList, count, totalPages };
    } catch (error) {
      console.error('fetchProducts error:', error);
      set({ 
        products: [], 
        loading: false, 
        error: error.response?.data?.message || error.message 
      });
      throw error;
    }
  },
  
  // دریافت دسته‌بندی‌ها
  fetchCategories: async () => {
    set({ loading: true, error: null });
    try {
      const response = await productService.getCategories();
      set({ categories: response.data || [], loading: false });
      return response.data;
    } catch (error) {
      console.error('fetchCategories error:', error);
      set({ 
        error: error.response?.data?.message || error.message, 
        loading: false 
      });
      throw error;
    }
  },
  
  // دریافت محصولات ویژه
  fetchFeaturedProducts: async () => {
    set({ loading: true, error: null });
    try {
      const response = await productService.getFeatured();
      const featuredData = response.data?.results || response.data || [];
      set({ featuredProducts: featuredData, loading: false });
      return featuredData;
    } catch (error) {
      console.error('fetchFeaturedProducts error:', error);
      set({ 
        error: error.response?.data?.message || error.message, 
        loading: false 
      });
      throw error;
    }
  },
  
  // دریافت جدیدترین محصولات
  fetchNewestProducts: async () => {
    set({ loading: true, error: null });
    try {
      const response = await productService.getNewest();
      const newestData = response.data?.results || response.data || [];
      set({ newestProducts: newestData, loading: false });
      return newestData;
    } catch (error) {
      console.error('fetchNewestProducts error:', error);
      set({ 
        error: error.response?.data?.message || error.message, 
        loading: false 
      });
      throw error;
    }
  },
  
  // دریافت جزئیات یک محصول
  fetchProductBySlug: async (slug) => {
    set({ loading: true, error: null });
    try {
      const response = await productService.getBySlug(slug);
      set({ selectedProduct: response.data, loading: false });
      return response.data;
    } catch (error) {
      console.error('fetchProductBySlug error:', error);
      set({ 
        error: error.response?.data?.message || error.message, 
        loading: false 
      });
      throw error;
    }
  },
  
  // تغییر صفحه
  setPage: (page) => {
    const { pagination } = get();
    if (page >= 1 && page <= pagination.totalPages) {
      set({ 
        pagination: { ...pagination, currentPage: page }
      });
      return true;
    }
    return false;
  },
  
  // تغییر تعداد در هر صفحه
  setPageSize: (size) => {
    set({ 
      pagination: { 
        ...get().pagination, 
        pageSize: size,
        currentPage: 1 
      }
    });
  },
  
  // ========== Filter Actions ==========
  setSelectedCategory: (category) => set({ selectedCategory: category }),
  setSearchQuery: (query) => set({ searchQuery: query }),
  setPriceRange: (range) => set({ priceRange: range }),
  setSortBy: (sort) => set({ sortBy: sort }),
  setViewMode: (mode) => set({ viewMode: mode }),
  
  // Reset Filters
  resetFilters: () => set({
    selectedCategory: null,
    searchQuery: '',
    priceRange: { min: '', max: '' },
    sortBy: '-created_at',
  }),
  
  // Get Filters for API
  getFilters: () => {
    const state = get();
    const filters = {
      ordering: state.sortBy,
    };
    if (state.selectedCategory) filters.category = state.selectedCategory;
    if (state.searchQuery) filters.search = state.searchQuery;
    if (state.priceRange.min) filters.min_price = state.priceRange.min;
    if (state.priceRange.max) filters.max_price = state.priceRange.max;
    return filters;
  },
  
  // Clear error
  clearError: () => set({ error: null }),
}));